module.exports = __webpack_public_path__ + "img/888.4ec603da.png";